var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2812 33.811H32.4349C32.8003 33.811 33.1507 33.6659 33.409 33.4075C33.6674 33.1492 33.8125 32.7988 33.8125 32.4334V17.2798C33.8125 15.1088 33.3849 12.9592 32.5541 10.9535C31.7234 8.94787 30.5057 7.12548 28.9706 5.59042C27.4356 4.05535 25.6132 2.83767 23.6075 2.0069C21.6018 1.17613 19.4522 0.748535 17.2813 0.748535H17.2812C15.1103 0.748535 12.9607 1.17613 10.955 2.0069C8.94935 2.83767 7.12696 4.05536 5.59189 5.59043C4.05682 7.12549 2.83914 8.94789 2.00837 10.9536C1.17759 12.9592 0.75 15.1089 0.75 17.2798V17.2798C0.75 21.6642 2.49168 25.8689 5.59188 28.9692C8.69209 32.0694 12.8969 33.811 17.2812 33.811Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 15.1235H12.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0312 20.8735H12.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a79fcffd9c56cc40ef4541b0fbe52a34.svg";
export { ForwardRef as ReactComponent };